import { useEffect, useReducer } from 'react';

// Re-renders once a minute while active, so a relative age ("8m ago") stays current
export function useMinuteTick(active: boolean): void {
  const [, tick] = useReducer((count: number) => count + 1, 0);
  useEffect(() => {
    if (!active) return;
    const interval = setInterval(tick, 60_000);
    return () => clearInterval(interval);
  }, [active]);
}
